import { TrackingPropsInterface } from '@marriott/mi-ui-library';

export enum ALinkStandaloneSize {
  Small = 'Small',
  Medium = 'Medium',
  ExtraSmall = 'ExtraSmall',
}

interface ALinkStandalonePropsBase {
  text?: string;
  children?: React.ReactNode;
  size?: ALinkStandaloneSize;
  externalLink?: boolean;
  trackingProperties?: TrackingPropsInterface;
  custom_click_track_value?: string;
  preTrackVal?: string;
}

export interface ALinkStandaloneAnchorProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
}

export interface ALinkStandaloneButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  href?: undefined;
}

export type ALinkStandaloneProps = (ALinkStandaloneAnchorProps | ALinkStandaloneButtonProps) & ALinkStandalonePropsBase;
